import { ArrowChangeDown } from 'components/Icons/ArrowChangeDown'
import { ArrowChangeUp } from 'components/Icons/ArrowChangeUp'
import { HeaderCellWrapper, InfoIconContainer } from 'components/Tokens/TokenTable/TokenRow'
import { MouseoverTooltip } from 'components/Tooltip'
import { useAtomValue } from 'jotai/utils'
import { ReactNode } from 'react'
import { Info } from 'react-feather'
import { useTheme } from 'styled-components/macro'

import {
  LeaderboardsortAscendingAtom,
  LeaderboardSortMethod,
  LeaderboardsortMethodAtom,
  useLeaderboardSetSortMethod,
} from './state'

const HEADER_DESCRIPTIONS: Record<LeaderboardSortMethod, ReactNode | undefined> = {
  [LeaderboardSortMethod.POOLS]: undefined,
  [LeaderboardSortMethod.TVL]: undefined,
  [LeaderboardSortMethod.VOLUME]: undefined,
  [LeaderboardSortMethod.TOTAL_REWARDS]: undefined,
  [LeaderboardSortMethod.BRIBES]: undefined,
  [LeaderboardSortMethod.MY_VOLUME]: undefined,
  [LeaderboardSortMethod.EARN]: undefined,
}

export default function HeaderCell({
  category,
  justify,
}: {
  category: LeaderboardSortMethod // TODO: change this to make it work for trans
  justify?: string
}) {
  const theme = useTheme()
  const sortAscending = useAtomValue(LeaderboardsortAscendingAtom)
  const handleSortCategory = useLeaderboardSetSortMethod(category)
  const sortMethod = useAtomValue(LeaderboardsortMethodAtom)

  const description = HEADER_DESCRIPTIONS[category]

  return (
    <HeaderCellWrapper onClick={handleSortCategory} justify={justify}>
      {sortMethod === category && (
        <>
          {sortAscending ? (
            <ArrowChangeUp width={16} height={16} color={theme.textPrimary} />
          ) : (
            <ArrowChangeDown width={16} height={16} color={theme.textSecondary} />
          )}
        </>
      )}
      {category}
      {description && (
        <MouseoverTooltip text={description} placement="right">
          <InfoIconContainer>
            <Info width="16px" height="16px" />
          </InfoIconContainer>
        </MouseoverTooltip>
      )}
    </HeaderCellWrapper>
  )
}
